import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "./ui/button";
import { Search, TrendingUp, ArrowRight } from "lucide-react";
import { trackCTAClick } from "../lib/tracking";

export default function MobileStickyBar({ isAuthenticated }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const isMobile = window.innerWidth < 768;
    // Show on landing, top-deals, and SEO pages — not on dashboard/auth/pricing
    const showPaths = ["/", "/top-deals", "/best-real-estate-investment-deals", "/how-scoring-works", "/faq"];
    const shouldShow = isMobile && (showPaths.includes(location.pathname) || location.pathname.startsWith("/best-") || location.pathname.startsWith("/what-is") || location.pathname.includes("rule") || location.pathname.includes("cap-rate") || location.pathname.includes("markets"));
    setShow(shouldShow);
  }, [location.pathname]);

  if (!show) return null;

  const handleCTA = () => {
    trackCTAClick("mobile_sticky_bar", isAuthenticated ? "/dashboard" : "/auth");
    navigate(isAuthenticated ? "/dashboard" : "/auth");
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-background/95 backdrop-blur-md border-t border-border px-4 py-2.5 flex items-center gap-2" data-testid="mobile-sticky-bar">
      <div className="flex-1 min-w-0">
        <p className="text-xs font-bold truncate">Find your next deal</p>
        <p className="text-[10px] text-muted-foreground truncate">Analyze any property in seconds</p>
      </div>
      <Button
        size="sm"
        className="flex-shrink-0 h-8 text-xs bg-emerald-600 hover:bg-emerald-700 text-white"
        onClick={handleCTA}
        data-testid="mobile-sticky-cta"
      >
        {isAuthenticated ? (
          <><Search className="w-3 h-3 mr-1" />Search</>
        ) : (
          <><ArrowRight className="w-3 h-3 mr-1" />Start Free</>
        )}
      </Button>
    </div>
  );
}
